import { Component, ObjectManager } from '../../concepts/objects';
import { ActiveObject, resolve } from '../Container';
import { AdapterInfo } from './AdapterInfo';
import { EditorSession } from './EditorSession';
import { Physical } from './entities/Physical';
import { Selection } from './Selection';

export class ChaosMechanics extends ActiveObject {

    @resolve(ObjectManager) private readonly objects!: ObjectManager;
    @resolve(EditorSession) private readonly session!: EditorSession;

    public start = () => this.burden(
        this.objects.on('updated', this.onModelUpdated),
    );

    private onModelUpdated = (ticked: Component[]) => {
        const zombies = ticked.filter(x => !x.alive && x.is(Physical)) as Physical[];
        if (!zombies.length) return;
        this.exitAdapter(zombies);
        this.exitSelection(zombies);
    };

    private exitAdapter(zombies: Physical[]) {
        const ai = this.session.get(AdapterInfo);
        for (const z of zombies) {
            if (ai.target === z.id) {
                this.session.update(AdapterInfo, AdapterInfo.empty);
            }
        }
    }

    private exitSelection(zombies: Physical[]) {
        const selection = this.session.get(Selection);
        const hits = zombies.filter(x => selection.has(x as any));
        if (!hits.length) return;
        this.session.apply(Selection, x => x.deleteMany(hits));
    }
}
